const { createLogger } = require('@vestiaire/logger');
const { version } = require('../../../../package.json');

const loggerInstance = createLogger({
  appName: process.env.APP_NAME ?? 'fenx',
  appType: process.env.APP_TYPE ?? 'web',
  env: process.env.LOG_ENV,
  appVersion: version,
  browserLogging: process.env.LOG_ENV !== 'prod',
});

module.exports = loggerInstance;
